var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "div" } },
    [
      _c(
        "w-card-content",
        { staticClass: "mail-head" },
        [
          _c(
            "w-row",
            [
              _c("w-col", { attrs: { xs: "3", md: "2" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("sent-info.from")) + " "),
              ]),
              _c("w-col", { attrs: { xs: "9", md: "10" } }, [
                _vm._v(" " + _vm._s(_vm.mailInfo.From) + " "),
              ]),
              _c("w-col", { attrs: { xs: "3", md: "2" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("sent-info.to")) + " "),
              ]),
              _c("w-col", { attrs: { xs: "9", md: "10" } }, [
                _vm._v(" " + _vm._s(_vm.to) + " "),
              ]),
              _c("w-col", { attrs: { xs: "3", md: "2" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("sent-info.cc")) + " "),
              ]),
              _c("w-col", { attrs: { xs: "9", md: "10" } }, [
                _vm._v(" " + _vm._s(_vm.cc) + " "),
              ]),
              _c("w-col", { attrs: { xs: "3", md: "2" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("sent-info.bcc")) + " "),
              ]),
              _c("w-col", { attrs: { xs: "9", md: "10" } }, [
                _vm._v(" " + _vm._s(_vm.bcc) + " "),
              ]),
              _c("w-col", { attrs: { xs: "3", md: "2" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("sent-info.subject")) + " "),
              ]),
              _c("w-col", { attrs: { xs: "9", md: "10" } }, [
                _vm._v(" " + _vm._s(_vm.mailInfo.Subject) + " "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        {
          style: { minHeight: "200px" },
          attrs: { tag: "w-card-content", x: "", y: false },
        },
        [
          _c("div", {
            directives: [
              {
                name: "safe-html",
                rawName: "v-safe-html",
                value: _vm.mailInfo.Content,
                expression: "mailInfo.Content",
              },
            ],
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }